import { ActionContext, Getter } from 'vuex';
import { RootState, TrackingState, TrackingConsentData } from '../types';
import { TRACKING_SET_CONSENT, TRACKING_INCREMENT_COUNT } from '../mutation-types';

// initial state
const initialState: TrackingState = {
  consent: {
    marketing: false,
    statistics: false,
    preferences: false,
    necessary: false,
  },
  initialized: false,
  setCount: null,
};

// getters
const getters: { [key: string]: Getter<TrackingState, RootState> } = {
  analyticsConsent(state) {
    return state.consent.statistics;
  },
};

// eslint-disable-next-line @typescript-eslint/init-declarations
let consentResolver: (consent: TrackingConsentData) => void;

const initialConsent = new Promise((resolve: (consent: TrackingConsentData) => void) => {
  consentResolver = resolve;
});

// actions
const actions = {
  setConsent({ state, commit }: ActionContext<TrackingState, RootState>, { data }: { data: TrackingConsentData }) {
    commit(TRACKING_SET_CONSENT, data);

    commit(TRACKING_INCREMENT_COUNT);

    consentResolver(state.consent);
  },

  async requestInitialConsent({ state }: ActionContext<TrackingState, RootState>) {
    await initialConsent;

    return state.consent;
  },
};

// mutations
const mutations = {
  [TRACKING_SET_CONSENT](currentState: TrackingState, data: TrackingConsentData) {
    currentState.consent = data;
    currentState.initialized = true;
  },

  [TRACKING_INCREMENT_COUNT](currentState: TrackingState) {
    currentState.setCount++;
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
